import React, { ComponentProps } from 'react';
import { Button, Icon } from '@common/components';

export function AttachmentButton({
  children,
  ...props
}: Omit<ComponentProps<typeof Button>, 'icon' | 'iconRight'>) {
  return (
    <Button {...props} icon={<Icon icon="paperclip" />}>
      {children}
    </Button>
  );
}
